export const isLeftClick = (event: React.MouseEvent) => {
  return event.button === 0;
};
